import en from "./en.json";
import nl from "./nl.json";
import de from "./de.json";
import fr from "./fr.json";
import es from "./es.json";
import it from "./it.json";
import pt from "./pt.json";
import { MarketingLangCode } from "i18n/urlLocale";

/**
 * UI-string translations for the public marketing pages (Home, About, Contact,
 * feature/business pages, etc). Separate from frontend/src/i18n — that module's
 * SUPPORTED_LANGUAGES covers only 5 languages and belongs to the B2B trip
 * website builder. Marketing pages match the blog's 7-language set instead.
 */
const marketingTranslations: Record<MarketingLangCode, Record<string, string>> = { en, nl, de, fr, es, it, pt };

export function getMarketingTranslations(lang: string): Record<string, string> {
	return marketingTranslations[lang as MarketingLangCode] || marketingTranslations.en;
}
